<template>
  <div class="d-flex flex-column flex-grow-1">
    <TabHeader :header="$t('js.sidebar.headers.candidacies')" />
    <div class="flex-grow-1 p-3 bg-blur-dark pretty-scroll-theme"
         id="chat"
         @scroll="checkScroll"
         style="overflow-y: auto; height: 0;">

      <div v-if="candidacies.length < 1" class="text-white-50 font-italic text-center">
        {{ $t('js.sidebar.candidacies.no_candidacies') }}
      </div>
      <Candidacy v-for="item in candidacies" :item="item" :key="`candidacy_${item.id}`"/>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
  import TabHeader from "./TabHeader"
  import SectionList from "../../shared/SectionList"
  import Candidacy from "../../shared/posts/Candidacy"

  export default {
    name: 'Candidacies',
    components: {Candidacy, SectionList, TabHeader},
    data(){
      return {
        scrolled: false
      }
    },
    computed: {
      ...mapState(['election', 'voting', 'posts', 'slides', 'chatUser']),
      ...mapGetters(['activeSlide', 'firstAvailableLocale']),
      candidacies(){
        return this.posts.filter(p => p.type === 'Candidacy')
      },
      ballotSlides(){
        return this.slides.filter(s => s.type === 'Slides::BallotSlide')
      }
    },
    watch: {
      posts: function(posts){
        if(!this.scrolled){
          this.$nextTick(function () {
            let d = $('#chat');
            d.scrollTop(d.prop("scrollHeight"));
          })
        }

      },
    },
    methods: {
      ...mapMutations(['markAllPostsRead']),
      ...mapActions(['updateStatus']),
      validateForm(){
        this.errors = []

        if(!this.target_slide_id){
          this.errors.push('slide_required')
        }
        if(this.message.length < 1){
          this.errors.push('motivation_required')
        }

        return this.errors.length === 0
      },
      checkScroll(){
        let d = $('#chat');
        this.scrolled = (d.scrollTop() ) < (d.prop("scrollHeight") - d.prop("offsetHeight"))
      }
    },
    mounted(){
      if(this.activeSlide && this.activeSlide.type === 'Slides::BallotSlide'){
        this.target_slide_id = this.activeSlide.id
      }

      this.$nextTick(function () {
        let d = $('#chat');
        d.scrollTop(d.prop("scrollHeight"));
      })
    }
  }
</script>
